<template>
  <v-row justify="center">
    <v-dialog v-model="visible" v-if="this.currentPrice" persistent max-width="800">
      <v-form ref="form" @submit.prevent="handleSubmit">
        <v-card :loading="loading">
          <v-card-title>
            <span class="headline">{{$t('modal.updateSubscription.title')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <!-- Current plan -->
              <v-row>
                <v-col>
                  <div class="overline">Current Plan</div>
                  <b>{{currentPrice.title}}</b>
                </v-col>
                <v-col>
                  <div class="overline">Rate Limit</div>
                  <b>{{currentPrice.searchLimit}}</b> Searches / month
                  <br />
                  <b>{{currentPrice.userLimit}}</b> Users
                </v-col>
                <v-col>
                  <div class="overline">Subscription Fee</div>
                  <b>${{currentPrice.rate}}</b> USD / month
                  <br />
                  <b>${{currentPrice.additionalSearch}}</b> Per additional search
                </v-col>
              </v-row>

              <!-- Select a new plan -->
              <v-row>
                <v-col>
                  <v-item-group v-model="newPrice">
                    <v-row>
                      <v-col v-for="price in getPrices(false)" :key="price.id">
                        <v-item v-slot:default="{ active, toggle }" :value="price.id" @click.native="enableSave()">
                          <v-card
                            @click="toggle"
                            tile
                            outlined
                            :disabled = "price.id === currentPrice.id"
                            :color="active ? 'blue lighten-5' : ''"
                          >
                            <v-card-text>
                              <h3 class="pb-5">{{price.title}}</h3>

                              <v-row no-gutters>
                                <v-col>
                                  <div class="overline">Rate Limit</div>
                                  <b>{{price.searchLimit}}</b> Searches / month
                                  <br />
                                  <b>{{price.userLimit}}</b> Users
                                </v-col>

                                <v-col>
                                  <div class="overline">Subscription Fee</div>
                                  <b>${{price.rate}}</b> USD / month
                                  <br />
                                  <b>${{price.additionalSearch}}</b> Per additional search
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-item>
                      </v-col>
                    </v-row>
                  </v-item-group>
                </v-col>
              </v-row>
              <v-card color="green lighten-5">
                <v-card-text>
                  <b>Note</b> Any current overages will be billed on the new subscription invoice
                  at the new subscription rate.
                </v-card-text>
              </v-card>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="onCancel">{{$t('label.cancel')}}</v-btn>
            <v-btn color="blue darken-1" type="submit" :disabled="saveDisabled">{{$t('label.save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UpdateSubscription",
  computed: {
    ...mapGetters(["getPrices"])
  },
  data() {
    return {
      newPrice: "",
      saveDisabled: true,
      rules: {
        required: value => !!value || "Required"
      }
    };
  },
  props: {
    currentPrice: {},
    error: {},
    loading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSubmit() {
      this.saveDisabled = true
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.$emit("onConfirmed", this.newPrice);
    },
    onCancel() {
      this.loading = false
      this.saveDisabled = true
      this.newPrice = ""
      this.$emit("onCancelled")
    },
    enableSave(){
      this.saveDisabled = false
    }
  }
};
</script>

<style>
.noBorder {
  box-shadow: none;
  border-color: white !important;
}
</style>